(() => {
  const images = JSON.parse(document.getElementById('sumna-images').textContent);
  const looks = {terre:{title:'La silhouette marron',images:['terre','terre-assise','editorial']},sable:{title:'La silhouette beige',images:['sable']}};
  let opener;
  function setLook(key) {
    const look=looks[key], dialog=document.getElementById('look-dialog');
    if (!look || !dialog) return;
    const photo=dialog.querySelector('#look-image'),thumbs=dialog.querySelector('.thumbnails');
    dialog.querySelector('#look-title').textContent=look.title;
    const cover=document.querySelector('[data-look="'+key+'"] img');
    photo.src=cover?.src || images[look.images[0]]; photo.alt=look.title;
    dialog.querySelectorAll('details').forEach((d,i)=>d.open=i===1);
    thumbs.replaceChildren();
    look.images.forEach((name,i)=>{
      const b=document.createElement('button'),img=document.createElement('img');
      b.type='button'; b.setAttribute('aria-label','Voir la photo '+(i+1)); b.setAttribute('aria-pressed',String(i===0));
      img.src=i===0 && cover ? cover.src : images[name]; img.alt=''; b.append(img);
      b.addEventListener('click',()=>{photo.src=img.src;thumbs.querySelectorAll('button').forEach(el=>el.setAttribute('aria-pressed',String(el===b)))});
      thumbs.append(b);
    });
    dialog.querySelectorAll('[data-color]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.color===key)));
  }
  document.addEventListener('click',e=>{
    const menu=e.target.closest('.menu'),nav=document.querySelector('nav');
    if(menu && nav){const open=menu.getAttribute('aria-expanded')!=='true';menu.setAttribute('aria-expanded',String(open));nav.classList.toggle('open',open)}
    if(e.target.closest('nav a')){nav?.classList.remove('open');document.querySelector('.menu')?.setAttribute('aria-expanded','false')}
    const look=e.target.closest('[data-look]'),color=e.target.closest('[data-color]'),dialog=document.getElementById('look-dialog');
    if(look && dialog){opener=look;setLook(look.dataset.look);dialog.showModal();document.body.classList.add('modal-open')}
    if(color) setLook(color.dataset.color);
    if(e.target.closest('.close')) dialog?.close();
    if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}
  });
  document.addEventListener('close',e=>{if(e.target.id==='look-dialog'){document.body.classList.remove('modal-open');opener?.focus()}},true);
  document.addEventListener('shopify:section:unload',()=>document.body.classList.remove('modal-open'));
})();
